import React, { ChangeEvent, useEffect, useRef, useState } from "react";
import { Icon } from "./icon";
import { useSearchspringContext } from "@app/providers/searchspring";
import { SHOPIFY_EVENTS } from "@app/lib/events";

const dispatchShopifySearchTerm = (query: string) => {
  if (!query) return;
  document.dispatchEvent(new CustomEvent(SHOPIFY_EVENTS.QUICK_SEARCH, { detail: { searchQuery: query } }));
};

export function SearchInput() {
  const [query, setQuery] = useState("");
  const inputRef = useRef<HTMLInputElement | null>();

  const { refine } = useSearchspringContext();

  function handleChange(event: ChangeEvent<HTMLInputElement>) {
    setQuery(event.target.value ?? "");
  }

  function handleClear() {
    setQuery("");
  }

  useEffect(() => {
    const timeout = setTimeout(() => {
      refine("query", query);
      dispatchShopifySearchTerm(query);
    }, 400);

    return () => {
      clearTimeout(timeout);
    };
  }, [query]);

  useEffect(() => {
    if (!inputRef.current) return;
    window.addEventListener("hashchange", (e) => {
      if (window.location.hash.includes("#search")) {
        setTimeout(() => {
          inputRef.current?.click();
          inputRef.current?.focus();
        }, 10);
      }
    });
  }, [inputRef]);

  return (
    <div className="flex items-center gap-2 px-4 border rounded-full focus-within:bg-grey-neutrals-4 max-w-208 grow border-neutrals-grey-3 focus-within:border-2 focus-within:border-neutrals-black">
      <Icon id="Search" className="size-4 shrink-0" />
      <input
        type="text"
        ref={inputRef}
        autoFocus
        className="h-10 grow focus:outline-none"
        onChange={handleChange}
        value={query}
        placeholder="Search"
      />
      <button onClick={handleClear} className="shrink-0">
        <Icon id="CrossCircle" className="size-4" />
      </button>
    </div>
  );
}
